const loginBtn = document.querySelector('.login-btn');

if (loginBtn) {
    loginBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        if (loginBtn.classList.contains('is-disabled')) return;

        // Lock button + show spinner
        loginBtn.classList.add('is-disabled', 'is-loading');

        // 🔑 Force paint before fetch
        await new Promise(requestAnimationFrame);

        const email = document.querySelector('#login_email').value;
        const password = document.querySelector('#login_password').value;
        const csrfToken = document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value;

        try {
            const response = await fetch('/actions/nf/event-manager/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                },
                body: JSON.stringify({ email, password })
            });
            
            const data = await response.json();
    
            if( data.success ){
                setTimeout(() => {
                    window.location.href = "/arrangementer";
                }, 150);
                return;
            }
    
            const errorDiv = document.querySelector('.login__errors span');
            if (errorDiv)
                errorDiv.textContent = data.message;
        } catch( error ) {
            console.log("Error during login: ", error);
            alert("Login has failed. Please try again.");
        }

        // Re-enable button on failure
        loginBtn.classList.remove('is-disabled', 'is-loading');
    });
}